<div class="container mt-3">
    <div class="cssmtgb just_center">
        <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
            (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Collection">
                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Collections</span>

                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="col-md-12">

                            <app-button (refreshClicked)="clearFilter()"></app-button>

                            <button type="button" class="btn excel_btn text-nowrap mr-2"
                                (click)="exportAsXLSX('Collection_')">
                                <i class="fa fa-file-excel"></i> Export
                            </button>

                            <button type="button" class="btn excel_btn text-nowrap mr-2"
                                (click)="collectionexportAsXLSX('Collection_')">
                                <i class="fa fa-file-excel"></i> Collections Report
                            </button>
                        </div>
                        <form [formGroup]="form">
                            <div class="row mt-3">
                                <div class="col-xl-3 d-none d-md-block">
                                </div>
                                <div class="col-xl-5 padd-right-file" style="display: flex;">
                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'searchText-mat-field'">
                                        <mat-label>Search</mat-label>
                                        <div class="search-input-container">
                                            <input formControlName="searchQuery"
                                                placeholder="Enter Customer Number / Application / Name / Contact Number"
                                                id="search" matInput type="text" #searchInput>
                                        </div>
                                    </mat-form-field>
                                    <button matSuffix mat-icon-button aria-label="Search"
                                        class="badge bg-light-blue image-button" (click)="search(true)">
                                        <mat-icon style="color: white;">search</mat-icon>
                                    </button>
                                </div>
                                <button type="button" class="btn reset_btn" (click)="clearFilter()">
                                    <i class="fa fa-refresh"></i> reset
                                </button>
                            </div>
                        </form>
                        <div class="table-responsive table-container mt-4 mb-4" *ngIf="showcollection">
                            <mat-table #table [dataSource]="dataSource" class="mat-table">
                                <ng-container matColumnDef="FNO">
                                    <mat-header-cell *matHeaderCellDef>FNO</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <p class="text-truncate txtalign">{{dataField.serviceProviderName}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Application">
                                    <mat-header-cell *matHeaderCellDef> Application</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign">{{dataField.applicationReferenceNumber}}
                                        </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Code">
                                    <mat-header-cell *matHeaderCellDef>Code</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <p class="text-truncate txtalign">{{dataField.userRefrenceNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Name">
                                    <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign">{{dataField.customerName}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Contact">
                                    <mat-header-cell *matHeaderCellDef>Contact</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign mb-2">
                                            {{dataField.mobileNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Address">
                                    <mat-header-cell *matHeaderCellDef>Address</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 15%;">
                                        <p class="text-truncate txtalign ">
                                            {{dataField.address}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="CollectionDate">
                                    <mat-header-cell *matHeaderCellDef>Collection Date</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField.collectionDate | date:'dd-MMM-yy'}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="CollectionNotes">
                                    <mat-header-cell *matHeaderCellDef>Collection Notes</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField.collectionComments}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Agent">
                                    <mat-header-cell *matHeaderCellDef>Agent</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField.collectionAgentName}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Action">
                                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <div class="row justify-content-start align-items-center">
                                            <div class=" col-2 ml-2" style="align-items: center; ">
                                                <i style="cursor: pointer; font-size: 18px; color: #9a00da;"
                                                    *ngIf="dataField.collectionStatus!=1" class="fa fa-edit mr-4"
                                                    title="Edit"
                                                    (click)="view(dataField.userRefrenceNumber,true,'Collection')"></i>
                                                <i style="cursor: pointer; font-size: 18px; color: red;"
                                                    *ngIf="dataField.collectionStatus==1" class="fa fa-close mr-4"
                                                    title="Revert Collection"
                                                    (click)="view(dataField.userRefrenceNumber,false,'Collection')"></i>
                                            </div>
                                        </div>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                                </mat-row>
                            </mat-table>
                            <div *ngIf="data.length == 0" class="no-data-message">
                                <p>No data found</p>
                            </div>
                        </div>

                        <div class="table_pagenation" [hidden]="!showcollection">
                            <mat-paginator #paginators [length]="dataSource!==null && dataSource.filteredData.length"
                                [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                            </mat-paginator>
                        </div>

                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Legal Collection">
                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Legal Collections</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="col-md-12">

                            <app-button (refreshClicked)="clearFilter()"></app-button>

                            <button type="button" class="btn excel_btn text-nowrap mr-2"
                                (click)="exportAsXLSX('LegalCollection_')">
                                <i class="fa fa-file-excel"></i> Export
                            </button>

                            <button type="button" class="btn excel_btn text-nowrap mr-2"
                                (click)="collectionexportAsXLSX('LegalCollection_')">
                                <i class="fa fa-file-excel"></i> Generate Report
                            </button>
                            <button type="button" class="btn btn-primary text-nowrap mr-2"
                                (click)="importexcel('legalexcelimport','Bulk Legal Collection')">
                                Bulk Legal Collection
                            </button>
                            <button type="button" class="btn btn-primary text-nowrap "
                                (click)="importexcel('legalexcelrevoke','Revert Legal Collection')">
                                Bulk Revert Legal Collection
                            </button>
                        </div>
                        <form [formGroup]="form">
                            <div class="row mt-3">
                                <div class="col-xl-3 d-none d-md-block">
                                </div>
                                <div class="col-xl-5 padd-right-file" style="display: flex;">
                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'searchText-mat-field'">
                                        <mat-label>Search</mat-label>
                                        <div class="search-input-container">
                                            <input formControlName="searchQuery"
                                                placeholder="Enter Customer Number / Application / Name / Contact Number"
                                                id="search" matInput type="text" #searchInput>
                                        </div>
                                    </mat-form-field>
                                    <button matSuffix mat-icon-button aria-label="Search"
                                        class="badge bg-light-blue image-button" (click)="search(false)">
                                        <mat-icon style="color: white;">search</mat-icon>
                                    </button>
                                </div>
                                <button type="button" class="btn reset_btn" (click)="clearFilter()">
                                    <i class="fa fa-refresh"></i> reset
                                </button>
                            </div>
                        </form>
                        <div class="table-responsive table-container mt-4 mb-4" *ngIf="showcollection">
                            <mat-table #table [dataSource]="dataSource" class="mat-table">
                                <ng-container matColumnDef="FNO">
                                    <mat-header-cell *matHeaderCellDef>FNO</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <p class="text-truncate txtalign">{{dataField.serviceProviderName}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Application">
                                    <mat-header-cell *matHeaderCellDef> Application</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign">{{dataField.applicationReferenceNumber}}
                                        </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Code">
                                    <mat-header-cell *matHeaderCellDef>Code</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <p class="text-truncate txtalign">{{dataField.userRefrenceNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Name">
                                    <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign">{{dataField.customerName}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Contact">
                                    <mat-header-cell *matHeaderCellDef>Contact</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign mb-2">
                                            {{dataField.mobileNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Address">
                                    <mat-header-cell *matHeaderCellDef>Address</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 15%;">
                                        <p class="text-truncate txtalign ">
                                            {{dataField.address}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="CollectionDate">
                                    <mat-header-cell *matHeaderCellDef>Collection Date</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField.legalCollectionDate | date:'dd-MMM-yy'}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="CollectionNotes">
                                    <mat-header-cell *matHeaderCellDef>Collection Notes</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField.legalCollectionComments}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Agent">
                                    <mat-header-cell *matHeaderCellDef>Agent</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField.legalCollectionAgentName}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Action">
                                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <div class="row justify-content-start align-items-center">
                                            <div class=" col-2 ml-2" style="align-items: center; ">
                                                <i style="cursor: pointer; font-size: 18px; color: #9a00da;"
                                                    *ngIf="dataField.collectionStatus!=2" class="fa fa-edit mr-4"
                                                    title="Edit"
                                                    (click)="view(dataField.userRefrenceNumber,true, 'legalCollection')"></i>
                                                <i style="cursor: pointer; font-size: 18px; color: red;"
                                                    *ngIf="dataField.collectionStatus==2" class="fa fa-close mr-4"
                                                    title="Revert Legal Collection"
                                                    (click)="view(dataField.userRefrenceNumber,false,'legalCollection')"></i>
                                            </div>
                                        </div>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                                </mat-row>
                            </mat-table>
                            <div *ngIf="data.length == 0" class="no-data-message">
                                <p>No data found</p>
                            </div>

                        </div>

                        <div class="table_pagenation" *ngIf="dataSource.filteredData.length">
                            <mat-paginator #paginators [length]="dataSource!==null && dataSource.filteredData.length"
                                [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                            </mat-paginator>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>